import { useGlobalEvent } from '@highlight/ipc/react'
import HighlightLogoIcon from '@renderer/components/Icons/HighlightLogoIcon'
import { AsrSetupToast } from '@renderer/presentations/toasts/AsrSetupToast'
import { DailySummaryToast } from '@renderer/presentations/toasts/daily-summary-toast'
import { Summary, SummaryItem } from '@renderer/chat/types'
import { useToast } from '../use-toast'

type ToastApi = ReturnType<typeof useToast>

export function useAudioSummaryToasts(toast: ToastApi) {
  useGlobalEvent('toast:asrSetup', () => {
    toast.add({
      analytics: { type: 'audio setup' },
      icon: <HighlightLogoIcon size={24} />,
      title: 'Audio Setup',
      duration: Infinity,
      autoExpandDelayMs: 0,
      autoCollapseDelayMs: 5000,
      body: (toastId) => <AsrSetupToast toastId={toastId} />,
    })
  })

  useGlobalEvent(
    'toast:daily-summary',
    ({ summary, timePeriod }: { summary: Summary | SummaryItem; timePeriod: 'Yesterday' | 'Last Week' }) => {
      toast.add({
        analytics: { type: 'daily summary', timePeriod },
        icon: <HighlightLogoIcon size={24} />,
        title: 'Your Daily Summary is Ready',
        duration: 2 * 60 * 1000,
        autoExpandDelayMs: 0,
        autoCollapseDelayMs: 5000,
        body: (toastId) => <DailySummaryToast toastId={toastId} summary={summary} timePeriod={timePeriod} />,
      })
    },
  )
}
